import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-launchpad',
  standalone: true,
  templateUrl: './launchpad.component.html'
})
export class LaunchpadComponent {
  public state = inject(AppStateService);
}
